/**
 * Chat rendering strategy (see chat UI SDK research plan).
 *
 * Primary: Streamdown for streaming markdown on the existing Grigo SSE pipeline.
 * Secondary POC: assistant-ui ExternalStoreRuntime (opt-in via env).
 * Not chosen: full AI SDK + assistant-ui-ai-sdk (backend protocol mismatch).
 */

export type ChatRenderPath = 'streamdown-primary';

export const CHAT_RENDER_PATH: ChatRenderPath = 'streamdown-primary';

function envFlag(name: string, defaultEnabled: boolean): boolean {
  const raw = (process.env[name] ?? '').trim().toLowerCase();
  if (raw === '') return defaultEnabled;
  return raw === '1' || raw === 'true' || raw === 'yes';
}

/** Streamdown replaces react-markdown for assistant text (default on). Set REACT_APP_CHAT_STREAMDOWN=false to revert. */
export function isChatStreamdownEnabled(): boolean {
  return envFlag('REACT_APP_CHAT_STREAMDOWN', true);
}

/** Read-only assistant-ui Thread POC alongside custom chat (default off). */
export function isChatAssistantUiPocEnabled(): boolean {
  return envFlag('REACT_APP_CHAT_ASSISTANT_UI_POC', false);
}
